import { useContext, useEffect } from "react";
import OLTileLayer from "ol/layer/Tile";
import MapContext from "views/OLMap/Map/MapContext";

const TileLayer = ({ source, zIndex = 0, className, baseLayer, ...props }) => {
  const { map } = useContext(MapContext);
  useEffect(() => {
    if (!map) return;

    const tileLayer = new OLTileLayer({
      source,
      zIndex,
      className,
      baseLayer,
      ...props,
    });
    map.addLayer(tileLayer);
    tileLayer.setZIndex(zIndex);
    // eslint-disable-next-line consistent-return
    return () => {
      if (map) {
        map.removeLayer(tileLayer);
      }
    };
  }, [map]);
  return null;
};
export default TileLayer;
